"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getSlimGroup;
var _lodash = require("lodash");
function getSlimGroup(config) {
  var groups = (0, _lodash.get)(config, 'user.groups', []);
  var group = (0, _lodash.find)(groups, {
    group: {
      id: (0, _lodash.get)(config, 'groupId')
    }
  });
  return {
    id: (0, _lodash.get)(group, 'group.id'),
    name: (0, _lodash.get)(group, 'group.name'),
    is_coordination_center: (0, _lodash.get)(config, 'isCoordinationGroup'),
    state: (0, _lodash.get)(group, 'group.state')
  };
}